import { z } from 'zod';

export const categoryFilter = z.object({
    categoryValue: z.string(),
    categoryTranslatedValue: z.string().optional()
});

export type CategoryFilter = z.infer<typeof categoryFilter>;
